'use strict';

// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
//import euiPanelyta from 'v-components/euiPanelyta';
import euiUpload from 'v-components/euiUpload.vue';
import { ssoFiltreraDatatable } from 'v-components/ssoFiltreraDatatable';
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';

import euiMermeny from 'v-components/euiMermeny';
import euiDialog from 'v-components/euiDialog';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
//import { ssoPersaldoDatatable } from 'datatables/ssoPersaldoDatatable';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';
////import AllaSvgikoner from 'Svgikoner';
import axios from 'axios';
import objectToFormData from 'object-to-formdata';

//------------------------------------------------------------------------------------------------------------------------------

// Använd dessa Vue plugins:
Vue.use(ssoFiltreraDatatable);
Vue.use(ssoTogglaRaderIDatatable);

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoUpload = window.ssoUpload || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.

//##############################################################################################################################

//console.group('Skapa Vue-appen');
//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		[euiUpload.name]: euiUpload,
		//euiPanelyta,
		[euiMermeny.name]: euiMermeny,
		[euiDialog.name]: euiDialog,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		tabellen: null,		// Initialt så. null betyder 'ännu inte satt'

		menyalternativ: [
			{ text: 'Lägg till som widget på översiktssidan&hellip;', id: 'addWidget', ikon: 'laggTillPaOversiktssida' },
			{ text: 'Test: Visa dialogruta', id: 'testVisaDialogruta', ikon: 'stang' },
		],

		visaDialogrutan: false,
		//svgMarkup: AllaSvgikoner.Stang,

		// Ytterligare data finns i ssoStateStore!
	},

	computed: {
	},

	watch: {
	},

	methods: {
		onMenyalternativValt({ eventId, eventData }) {
			//switch (eventId)
			//{
			//	case 'addWidget':
			//	{
			//		// Todo: SKA FLYTTAS EV TILL HANDLER-KOMPONENT SOM INKLUDERAR SIDVAL:
			//		// '00000000-0000-0000-0000-000000000000'

			//		//let that = this;
			//		axios.post('/widget/add-widget', objectToFormData({
			//				pageId: '00000000-0000-0000-0000-000000000000',	//pageid,
			//				elementName: 'uploadwidget',	//that.elementnamn,
			//				parameters: '',	//that.parametrar,
			//				//? Här skulle gärna seetings följa med också
			//				settings: '{}'
			//			})
			//		)
			//		.then(response => {
			//				// Här går vi till den översiktssida vi lagt widgeten på ??
			//				//window.location.href = '/oversikt/' + pageid;
			//		})
			//		.catch(e => {
			//				console.error(e);
			//		});

			//		break;
			//	}

			//	case 'testVisaDialogruta':
			//	{
			//		this.visaDialogrutan = true;
			//		break;
			//	}				
			//}
		},

	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'upload';
	},


	mounted() {
		console.time('#TIMING: initieraDataTable');	// Todo: TEMP!!!
		console.timeEnd('#TIMING: initieraDataTable');	// Todo: TEMP!!!

		SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');


		this.$nextTick(function () {
		})
	},

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
//console.groupEnd('Skapa Vue-appen');

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
